export default function DeleteIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-w-4"
            aria-hidden="true"
            viewBox="0 0 24 24"
        >
            <path
                fill="#A3A8AF"
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
            ></path>
        </svg >
    )
}